module.exports = "/assets/0e15630fa705e86f97dde14ed396bd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/C6.png
// module id = 1254
// module chunks = 0